import styled from "styled-components";

export const Container = styled.div`
  padding: 0px;
`;

export const ProjectBox = styled.div`
  max-width: 1128px;
  margin: auto;
  padding: 0px 0 10px;
  display: grid;
  flex-wrap: wrap;
  flex-direction: row;
  grid-template-columns: auto auto auto auto;
  @media screen and (max-width: 1100px) {
    margin: 0px 30px;
    grid-template-columns: auto auto auto;
  }
  @media screen and (max-width: 768px) {
    margin: 10px 10px;
    grid-template-columns: auto auto;
  }
  @media screen and (max-width: 500px) {
    margin: 10px 10px;
    grid-template-columns: auto;
  }
`;

export const BigProjectBox = styled.div`
  max-width: 1128px;
  margin: auto;
  padding: 0px 0 10px;
  display: flex;
  flex-direction: row;

  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
  & > div {
    width: 25%;

    @media screen and (max-width: 1100px) {
      margin: 0px 30px;
      width: 33.33%;
    }

    @media screen and (max-width: 768px) {
      margin: 10px 10px;
      width: 50%;
    }

    @media screen and (max-width: 500px) {
      margin: 10px 10px;
      width: 100%;
      flex-direction: column;
    }
    /* img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    } */
  }

  /* @media (max-width: 768px) {
    margin: 10px 10px;
    flex-direction: column;
    & > div {
      width: 100%;
    }
  } */
`;
